// react-intl requires flattened objects so any key exported must be namespaced: {namespace}.{id}
export default {
  'requestAccessPage.greeting': 'Welcome',
  'requestAccessPage.details':
    'To view the conversation, please request an access code to continue.',
  'requestAccessPage.requestButton': 'Request Access Code',
  'requestAccessPage.footer':
    'This service should not be used for emergencies.  If you have an emergency please call 9-1-1 immediately.',
  'requestAccessPage.footerLabel': 'Access Code Footer',
  'requestAccessPage.footerIhis':
    'TigerTouch should not be used for emergencies. If you have an emergency please call 9-9-9 immediately.',
};
